import React, { useEffect } from "react";
import { CreateUserForm, FooterFilterMobile } from "../../components";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../../store";
import path from "../../ultils/path";

const UserCreatePage = () => {
  const navigate = useNavigate();
  const { token } = useAuthStore();
  useEffect(() => {
    if (!token) {
      navigate(path.SIGN_IN);
    }
  }, []);
  return (
    <div className="p-[1rem]">
      <p className="font-semibold text-gray-700 xl:mb-4 md:mb-3 mb-2">
        Create new user
      </p>
      <CreateUserForm></CreateUserForm>
      <FooterFilterMobile></FooterFilterMobile>
    </div>
  );
};

export default UserCreatePage;
